import { createSelector } from '@reduxjs/toolkit';
import { ESuggestedProductViewId } from 'core/model/enums/catalog.enum';
import { IState, TRootState } from '../reducers';

const getSectionsStateSelector = (state: TRootState) => state.suggestedProducts.sections;

export const getSuggestionsForSection = createSelector(
  getSectionsStateSelector,
  (_state: IState, sectionId: ESuggestedProductViewId) => sectionId,
  (sections, sectionId) => sections[sectionId],
);
